import { render } from "./BaseItemGroup.vue?vue&type=template&id=bed8d450&scoped=true"
import script from "./BaseItemGroup.vue?vue&type=script&lang=js"
export * from "./BaseItemGroup.vue?vue&type=script&lang=js"

import "./BaseItemGroup.vue?vue&type=style&index=0&id=bed8d450&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bed8d450"]])

export default __exports__